import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-progress-bar', $props.containerClass, {'is-over': $options.isOver}])
  }, [
    _createElementVNode("div", {
      style: _normalizeStyle({ width: `${$options.percentage}%` }),
      class: _normalizeClass([
                 {'is-transparent': $options.percentage === 0},
                 'gfu-progress-bar__progression', $props.progressionClass
             ])
    }, null, 6 /* CLASS, STYLE */),
    ($props.canGoOver)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          style: _normalizeStyle({ transform: `translateX(${$options.percentageOver}%)`}),
          class: _normalizeClass($props.progressionOverClass)
        }, null, 6 /* CLASS, STYLE */))
      : _createCommentVNode("v-if", true)
  ], 2 /* CLASS */))
}